import { Link } from "react-router-dom";
import { FcOrgUnit } from "react-icons/fc";
import HandleCurrentPath from "./HandleCurrentPath";
import { Ri24HoursFill } from "react-icons/ri";
const Menu = () => {
  const pathname = window.location.pathname;

  return (
    <>
      <ul className="mt-6">
        <li className="relative px-6 py-3">
          <HandleCurrentPath staticPath={"/"} currentPath={pathname} />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
            to={"/"}
          >
            <FcOrgUnit />
            <span className="ml-4">Dashboard</span>
          </Link>
        </li>
      </ul>

      <ul>
        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/hourlystats"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/hourlystats"}
          >
            <Ri24HoursFill />
            <span className="ml-4">Hourly Stats </span>
          </Link>
        </li>
      </ul>
    </>
  );
};
export default Menu;
